export default {
	seo_meta_title_leaguepass: 'НБА| NBA Video and Highlights',
	seo_meta_desc_leaguepass: 'NBA Video позволяет смотреть видео и ключевые моменты НБА',
	seo_meta_keywords_leaguepass: 'Видео НБА, ключевые моменты НБА, баскетбольные видео, лучшие комбинации, данки, репортажи',
	seo_meta_title_featured: 'NBA | Рекомендуемые',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'НБА| NBA TV Live',
	seo_meta_desc_nbatv: 'NBA TV Live — это непрерывный стрим на канале NBA TV в течение 24 часов в сутки: прямые трансляции и показ игр из архива НБА каждую неделю, студийные программы и комментарии аналитиков',
	seo_meta_keywords_nbatv: 'Канал NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, передачи из студии, the jump',
	seo_meta_title_classicgames: 'NBA | Классические игры',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | Список видео',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA | Эксклюзивные передачи NBA TV',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'Главная страница НБА',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | Каналы',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | Канал',
	seo_meta_pre_title_categories: 'NBA | Категории',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | Категория',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | Видео',
	seo_meta_pre_title_event: 'NBA | Событие',
	seo_meta_title_events: 'NBA | События',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | События: {0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | Поиск',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | Страница не найдена',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Игра НБА:',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'НБА| NBA Video and Highlights',
	seo_meta_desc_video: 'NBA Video позволяет смотреть видео и ключевые моменты НБА',
	seo_meta_keywords_video: 'Видео НБА, ключевые моменты НБА, баскетбольные видео, лучшие комбинации, данки, репортажи',
	seo_meta_title_channel: 'НБА| NBA TV Live',
	seo_meta_desc_channel: 'NBA TV Live — это непрерывный стрим на канале NBA TV в течение 24 часов в сутки: прямые трансляции и показ игр из архива НБА каждую неделю, студийные программы и комментарии аналитиков',
	seo_meta_keywords_channel: 'Канал NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, передачи из студии, the jump',
	seo_meta_title_tvguide: 'NBA | Программа NBA TV',
	seo_meta_desc_tvguide: 'NBA TV Live — это непрерывный стрим на канале NBA TV в течение 24 часов в сутки: прямые трансляции и показ игр из архива НБА каждую неделю, студийные программы и комментарии аналитиков',
	seo_meta_keywords_tvguide: 'Канал NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, передачи из студии, the jump',
	timezone: 'восточное время (ET)',
	default_feed_error_message: 'Что-то пошло не так, в настоящее время контент недоступен. Повторите попытку через некоторое время.',
	watch_in_app: 'СМОТРЕТЬ В ПРИЛОЖЕНИИ NBA',
	no_content: 'Контент отсутствует',
	see_more: 'Подробнее',
	now_playing: 'СЕЙЧАС ВОСПРОИЗВОДИТСЯ',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'Пакет League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Вы достигли максимального количества избранных видео. Пожалуйста, удалите некоторые из них, прежде чем добавлять новые.',
	item_live: 'Прямой эфир:',
	add_favourite_title: 'ДОБАВИТЬ В ИЗБРАННОЕ',
	remove_favourite_title: 'УДАЛИТЬ ИЗ ИЗБРАННОГО',
	p_channel_live: 'ПРЯМОЙ ЭФИР',
	p_channel_schedule_title: 'Расписание NBA TV',
	p_channel_schedule_watch: 'Смотреть',
	p_channel_schedule_no_date: 'В настоящее время дата расписания недоступна.',
	p_channel_live24x7_title: 'NBA TV круглосуточно',
	p_channel_live24x7_see_full_schedule: 'См. полное расписание',
	p_channel_live24x7_up_next: 'далее в программе',
	p_channel_live24x7_on_demand: 'NBA TV: по запросу',
	p_channel_live24x7_collection: 'Коллекция',
	p_channel_live24x7_demand_1_logo_text: 'оригинальные передачи',
	p_channel_live24x7_demand_1_show_name: 'Передачи NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Оригинальные передачи NBA TV, в том числе Shaqtin’ a Fool, Beyond the Paint, Game Time и Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Классические игры',
	p_channel_live24x7_demand_2_show_name: 'NBA | Классические игры',
	p_channel_live24x7_demand_2_show_desc: 'Смотрите классические игры полностью, в том числе все финальные матчи с 2000 года, исторические моменты лиг и выступления легендарных игроков.',
	p_channel_clips_title: 'Клипы NBA TV',
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Передачи',
	p_nba_tv_shows: 'Передачи NBA TV',
	p_nba_tv_no_access_title: 'NBA круглосуточно: оставайтесь в курсе событий благодаря анализу игр, студийному анализу, оригинальным программам и другому эксклюзивному контенту!',
	p_nba_tv_no_access_desc: 'Смотрите игры в прямом эфире, а также записи передач и классических игр.',
	p_nba_tv_no_access_note: 'Могут действовать ограничения на показ по ТВ',
	tv_show_item_latest_episode: 'последний выпуск',
	tv_show_item_no_latest_episode: 'нет последнего выпуска',
	see_all: 'Посмотреть все',
	header_menu_watch: 'Смотреть',
	header_menu_featured: 'ЛУЧШЕЕ',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'Пакет League Pass',
	players: 'Игроки',
	videos: 'Видео',
	teams: 'Команды',
	most_searched: 'САМЫЕ ПОПУЛЯРНЫЕ',
	no_result: 'Нет данных',
	search_filter_type_most_relevant: 'Самые релевантные',
	search_filter_type_most_viewed: 'Самые просматриваемые',
	search_filter_type_most_recent: 'Новейшие',
	search_filter_type_last_30_days: 'За последние 30 дней',
	search_filter_type_last_6_months: 'За последние 6 месяцев',
	search_result_label: 'Результаты поиска для \'{keyword}\'',
	search_result_info: 'Показать все результаты для {keyword}',
	search_placeholder: 'Поиск в видеотеке',
	load_more: 'Загрузить еще...',
	button_subscribe: 'Подписаться',
	button_sign_in: 'Вход',
	p_league_pass_no_access_title: 'Смотрите игры в прямом эфире или в режиме повтора на любом устройстве, в том числе на компьютере, смартфоне и телевизоре!',
	p_league_pass_no_access_desc: 'Ваш пропуск в самую гущу событий: смотрите матчи всей лиги или только своей любимой команды, выберите конкретную игру и ознакомьтесь с другими вариантами.',
	p_league_pass_no_access_note: 'Действуют условия',
	category_title: 'Видео',
	p_video_playlist_title: 'Список воспроизведения',
	p_no_access_league_pass_title: 'Разблокируйте NBA League Pass, чтобы получить доступ к следующему контенту:',
	p_no_access_league_pass_desc: 'Ваш пропуск в самую гущу событий: смотрите матчи всей лиги или только своей любимой команды, выберите конкретную игру и ознакомьтесь с другими вариантами.',
	p_no_access_league_pass_terms: 'Действуют условия',
	p_no_access_league_pass_geo_desc: 'Согласно данным о вашем местоположении, вы не можете просматривать эту игру в NBA League Pass и NBA TV. Архив этих игр будет доступен подписчикам NBA League Pass через 3 дня после трансляции. Ознакомьтесь с расписанием местных теле- и радиовещательных компаний, чтобы узнать, по каким каналам транслируются спортивные передачи в вашем регионе.',
	p_no_access_league_pass_not_found_desc: 'К сожалению, запрошенное видео не найдено.',
	p_no_access_event_not_found_desc: 'К сожалению, запрошенное событие не найдено.',
	p_no_access_nba_tv_title: 'Разблокируйте NBA TV, чтобы получить доступ к следующему контенту:',
	p_no_access_nba_tv_desc: 'Смотрите игры в прямом эфире, а также записи передач и классических игр.',
	p_no_access_nba_tv_terms: 'Действуют условия',
	p_no_access_nba_tv_geo_desc: 'Согласно данным о вашем местоположении, вы не можете просматривать эту игру в NBA League Pass и NBA TV. Архив этих игр будет доступен подписчикам NBA League Pass через 3 дня после трансляции. Ознакомьтесь с расписанием местных теле- и радиовещательных компаний, чтобы узнать, по каким каналам транслируются спортивные передачи в вашем регионе.',
	p_no_access_nba_tv_not_found_desc: 'К сожалению, запрошенный канал не найден.',
	p_no_access_up_next: 'Далее в программе:',
	p_video_completed_title: 'Список воспроизведения завершен',
	p_video_completed_desc: 'Вернитесь, чтобы просмотреть все списки воспроизведения и выбрать следующий',
	p_video_share_to: 'Поделиться с:',
	p_video_more_to_watch: 'Дополнительный контент:',
	p_event_section_title: 'МЕРОПРИЯТИЕ',
	p_event_playlist_title: 'Список воспроизведения',
	p_event_button_watch: 'Смотреть',
	p_event_button_listen: 'Слушать',
	p_event_button_ticket: 'Билет',
	notfound: 'К сожалению, страница не найдена.',
	notfound_desc: 'Пожалуйста, проверьте правильность написания URL<br/> или попробуйте воспользоваться навигацией по сайту или поиском.',
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Для вашей учетной записи NBA League Pass ведется слишком много потоковых трансляций. Нажмите кнопку «Продолжить», чтобы возобновить просмотр на данном устройстве.',
	modal_pcm_custom: 'Продолжить',
	modal_pcm_close: 'Отмена',
	modal_adobe_concurrency_header_title: 'Видеосоединение прервано',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: 'Потоковая трансляция закрыта. Возможные причины: превышение максимально допустимого количества потоков, потеря сетевого соединения или технические неполадки. Чтобы продолжить, войдите в систему еще раз и выберите канал.',
	modal_adobe_concurrency_close: 'Готово',
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Воспроизведение этого видео на вашем устройстве невозможно. Нажмите <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>ЗДЕСЬ</a> для получения поддержки.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'ОК',
	freesample_notice_time: 'Осталось времени:',
	freesample_notice_title: 'Вам предоставлено {0} минут доступа',
	freesample_notice_desc: 'Подпишитесь на полноценный пакет League Pass, чтобы продолжить смотреть игры по истечении 10 {0} минут.',
	freesample_notice_subscribe_button: 'Подписаться',
	freesample_notice_cancel_button: 'Отмена в любой момент',
	freesample_popup_title: 'ВРЕМЯ ДОСТУПА ИСТЕКЛО',
	freesample_popup_subtitle: 'Подпишитесь на League Pass, чтобы смотреть другие захватывающие игры NBA.',
	freesample_popup_link: 'Подробнее',
	freesample_popup_get_minutes_button: 'ПОЛУЧИТЬ {0}  МИНУТ',
	reg_required_desc: 'Для просмотра этого контента необходимо войти в систему',
	favorite_teams_title: 'Любимые команды',
	bookmarked_title: 'Сохранено',
	watch_history_title: 'Продолжить просмотр',
	game_schedule_title: 'Расписание игр',
	recommended_title: 'Рекомендуемые',
	season_text: 'Сезон',
	section_tv_provider_title: 'Мой ТВ-провайдер',
	section_tv_provider_desc: 'Получите доступ к играм и трансляциям в прямом эфире через вашего ТВ-провайдера.',
	section_tv_provider_faq: 'Часто задаваемые вопросы о ТВ-провайдерах',
	section_tv_provider_sign_out: 'Выход',
	header_menu_account_my_account: 'Мой аккаунт',
	header_menu_account_manage_account: 'Управление учетной записью',
	header_menu_account_favorite_teams: 'Любимые команды',
	header_menu_account_favorite_players: 'Любимые игроки',
	header_menu_account_viewing_history: 'История просмотров',
};
